module.exports = __webpack_public_path__ + "img/watermark.9af80463.png";